import React, { AriaRole } from 'react';
import { useSelector } from 'react-redux';
import { IconDeviceToolsOutline, IconDeviceToolsFill } from '@saucelabs/ds-icons';

import { CONFIGURATION_TEST_TYPES } from '../../../constants';
import * as globalSelectors from '../../../selectors';
import selectors from '../selectors';
import GenericPopover from './GenericPopover';
import GenericButton from './GenericButton';
import ButtonSetGpsLocation from './ButtonSetGpsLocation';
import ButtonCameraUpload from './ButtonCameraUpload';
import ButtonBiometricAuthentication from './ButtonBiometricAuthentication';
import ButtonUploadFileToSdCard from './ButtonUploadFileToSdCard';
import ButtonCopyToClipboard from './ButtonCopyToClipboard';
import ButtonBack from './ButtonBack';
import ButtonAdbShell from './ButtonAdbShell';

const ToolsButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const {
    deviceToolsDisabled,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);
  const {
    isAndroidDevice,
    shellCommandSupported,
  } = useSelector(globalSelectors.mobileSessionSelector);

  return (
    <GenericPopover
      trigger={(
        <GenericButton
          dataQa="live-session-toolbar-tools-group-button"
          disabled={deviceToolsDisabled}
          hasSubmenu
          icon={IconDeviceToolsOutline}
          iconHightlight={IconDeviceToolsFill}
          isPopoverTrigger
          label="Tools"
          role={role || 'menuitem'}
        />
      )}
    >
      <>
        {isAndroidDevice && (
          <ButtonBack role="menuitem" />
        )}

        {shellCommandSupported && (
          <ButtonAdbShell role="menuitem" />
        )}

        <ButtonSetGpsLocation role="menuitem" />

        {(testType === CONFIGURATION_TEST_TYPES.APP) && (
          <>
            <ButtonCameraUpload role="menuitem" />
            <ButtonBiometricAuthentication role="menuitem" />
          </>
        )}

        {isAndroidDevice && (
          <ButtonUploadFileToSdCard role="menuitem" />
        )}

        <ButtonCopyToClipboard role="menuitem" />
      </>
    </GenericPopover>
  );
};

ToolsButton.displayName = 'ToolsButton';

export default ToolsButton;
